"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Currencies = /** @class */ (function () {
    function Currencies() {
        this.currencies = {
            DE: "€",
            CH: "CHF",
        };
    }
    return Currencies;
}());
exports.Currencies = Currencies;
var StoreCurrency = /** @class */ (function () {
    function StoreCurrency() {
        this.currency = "DE";
        this.convert = false;
        this.conversion = 1;
    }
    return StoreCurrency;
}());
exports.StoreCurrency = StoreCurrency;
var State = /** @class */ (function () {
    function State() {
        this.activeCabinKey = "cabin1";
        this.basket = ["cabin1"];
        this.storeCurrency = new StoreCurrency();
        this.currencyList = new Currencies();
        this.currencyConversion = false;
        this.loading = null;
        this.resetFlex = false;
        this.lastRemovedCabin = 0;
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map